import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function EmergencyNav() {
  const { t } = useTranslation();
  const [value, setValue] = useState("/emergency");
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = ["/emergency", "/emergency/new"];
    if (validPaths.includes(path)) {
      setValue(path);
    } else {
      setValue("/emergency");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
            }}
          >
            {[
              { path: "/emergency", label: "Emergency" },
              { path: "/emergency/new", label: "New Visit" },
            ].map((tab, index) => (
              <Tab
                key={index}
                style={{
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  borderRadius: "10px",
                  backgroundColor:
                    value === tab.path ? theme.palette.primary.main : "white",
                  color: value === tab.path ? "white" : "black",
                }}
                label={tab.label}
                value={tab.path}
                component={NavLink}
                to={tab.path}
              />
            ))}
          </Tabs>
        </Paper>
        <Box sx={{ p: 1 }}>
          <Outlet />
        </Box>
      </Box>
    </Grid>
  );
}
